import styled from "styled-components";
import { css } from "styled-components";

interface IContainer {
  isyou?: boolean;
  haspermission?: boolean;
}

export const Container = styled.div<IContainer>`
  width: 100%;
  height: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 6px;
  margin-top: 2px;
  border-radius: 6px;
  cursor: ${({ haspermission, isyou }) => haspermission && !isyou ? 'pointer' : 'default'};
  
  .cardUserLeft {
    display: flex;
    flex-direction: row;
    align-items: center;

    .cardUserText {
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      color: ${({ theme }) => theme.colors.surface.onSurface};
      margin-left: 10px;
    }
  
    .tagAssigned {
      width: auto;
      height: 16px;
      display: flex;
      align-items: center;
      border-radius: 4px;
      background-color: ${({ theme }) => theme.colors.secondary.secondary};
      padding: 0 4px;
      margin-left: 4px;
  
      font-size: 10px;
      font-weight: 600;
      line-height: 12px;
      color: ${({ theme }) => theme.colors.surface.onSurface};
    }
  }

  .cardUserRight {
    margin-left: 10px;

    .cardUserIconEyeCheck {
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
    }

    .cardUserIconCancelar {
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
      display: none;
    }

    .cardUserIconAdd {
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
      display: none;
    }
  }

  ${({ isyou, haspermission }) => !isyou && haspermission && css`
    &:hover {
      background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};

      .cardUserRight {

        .cardUserIconEyeCheck {
          display: none;
        }

        .cardUserIconCancelar {
          display: flex;
        }

        .cardUserIconAdd {
          display: flex;
        }
      }
    }
  `}
`;
